module.exports = __webpack_public_path__ + "assets/arcadeweb1.jpg?96a5a74cf08cfabb1f2abd58ccd753a4";